module.exports = __webpack_public_path__ + "static/media/Maple-Hill-Bldg-Use-87.414b0cd1.pdf";